<template>
  <v-col
    cols="12"
    :class="
      'footer-text white mt-n5 ' + (!$vuetify.breakpoint.mdAndUp ? '' : 'px-1')
    "
  >
    <v-container
      :class="'pt-0 text-left ' + (!$vuetify.breakpoint.mdAndUp ? '' : 'px-0')"
    >
      <v-row
        dense
        :class="!$vuetify.breakpoint.mdAndUp ? '' : ''"
      >
        <v-col
          :cols="$vuetify.breakpoint.mdAndUp ? 8 : 12"
          :order="$vuetify.breakpoint.mdAndUp ? 1 : 2"
          class="pt-2"
        >
          {{ isMobileView ? '' : $i18n.t('footerMessage') }}
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.mdAndUp ? 4 : 12"
          :order="$vuetify.breakpoint.mdAndUp ? 2 : 1"
          style="font-size: 26px"
          class="text-right pb-5"
        >
          <i class="fab fa-cc-visa ml-2"></i>
          <i class="fab fa-cc-mastercard ml-2"></i>
          <i class="fab fa-cc-apple-pay ml-2"></i>
          <i class="fab fa-cc-amex ml-2"></i>
          <a
            v-if="['homewlang', 'object'].includes($route.name)"
            href="https://partner.costasolrent.com/"
            class="normal-link"
            target="_blank"
          >
            <span
              style="
                text-decoration: none;
                line-height: 40px;
                font-size: 15px;
                position: relative;
                padding-left: 30px;
                bottom: 3px;
                cursor: pointer;
              "
            >
              <i
                class="fa fa-users ml-2"
                style="font-size: 14px; margin-right: 5px"
              ></i>
              Partner
            </span>
          </a>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import moment from 'moment'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
import { isMobile } from 'is-mobile'
import sharedComputed from '@/methods/sharedComputed'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'PageFooter',
  methods: { isMobile },

  data() {
    return {
      originalWidth: window.innerWidth,
    }
  },

  computed: {
    ...sharedComputed,

    ...mapFields(Object.keys(state)),

    yearNumber() {
      return moment().format('Y')
    },
  },
}
</script>

<style>
.footer-text {
  color: gray;
}

@media screen and (max-width: 700px) {
  .footer-text {
    font-size: 11px;
  }
}
</style>
